import styled, { css } from 'styled-components';

interface StepItemProps {
  $isActive?: boolean;
}

export const DesktopContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 38px;
  width: 100%;
  max-width: 401px;
  position: relative;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const MobileClickableContainer = styled.div`
  display: none;

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    cursor: pointer;
  }
`;

export const MobileClickableText = styled.span`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 14px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  padding: 0;
  border-radius: 0;
  backdrop-filter: none;
  width: 100%;
`;

export const StepBadge = styled.div<StepItemProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 100px;
  flex-shrink: 0;
  position: relative;

  ${({ $isActive }) =>
  ($isActive
    ? css`
          background: #ffffff;
        `
    : css`
          background: #354A85;
        `)}
`;

export const StepBadgeInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  outline: 4px solid #4A60A7;
  background: #000000;
  position: absolute;
  top: 0;
  left: 0;
`;

export const StepNumber = styled.span<StepItemProps>`
  font-family: Inter, sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.714em;
  text-align: center;
  position: relative;
  z-index: 1;
  color: #ffffff;
`;

export const StepText = styled.span<StepItemProps>`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 1.25em;
  letter-spacing: 0.0125em;
  flex: 1;
  color: ${({ $isActive }) => ($isActive ? '#ffffff' : '#94A3B8;')};
`;

export const ListTitle = styled.h3`
  font-family: Inter, sans-serif;
  font-weight: 400;
  font-size: 20px;
  line-height: 1.4em;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  margin: 0 0 24px 0;
`;

export const StepDivider = styled.div`
  width: 1px;
  height: 60px;
  background: #cbd5e1;
  margin-left: 14px;
  margin-top: -48px;
  margin-bottom: -48px;
  flex-shrink: 0;
  align-self: flex-start;
`;